const mockYear1: number = 2021;

const mockYear2: number = 2019;

const mockYearArray: Array<number> = [mockYear1, mockYear2];

export { mockYearArray };
